import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

interface SkeletonLoaderProps {
  type: 'card' | 'list' | 'table' | 'chart';
  count?: number;
}

export function SkeletonLoader({ type, count = 3 }: SkeletonLoaderProps) {
  if (type === 'card') {
    return (
      <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4'>
        {Array.from({ length: count }).map((_, i) => (
          <Card key={i} className='h-48'>
            <CardHeader className='space-y-2'>
              <Skeleton className='h-4 w-3/4' />
              <Skeleton className='h-3 w-1/2' />
            </CardHeader>
            <CardContent className='space-y-2'>
              <Skeleton className='h-3 w-full' />
              <Skeleton className='h-3 w-4/5' />
              <div className='flex gap-2 mt-4'>
                <Skeleton className='h-6 w-16' />
                <Skeleton className='h-6 w-12' />
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  if (type === 'list') {
    return (
      <div className='space-y-3'>
        {Array.from({ length: count }).map((_, i) => (
          <div
            key={i}
            className='flex items-center space-x-4 p-4 border rounded-lg'
          >
            <Skeleton className='h-10 w-10 rounded-full' />
            <div className='space-y-2 flex-1'>
              <Skeleton className='h-4 w-1/3' />
              <Skeleton className='h-3 w-2/3' />
            </div>
            <Skeleton className='h-8 w-20' />
          </div>
        ))}
      </div>
    );
  }

  if (type === 'table') {
    return (
      <div className='space-y-3'>
        <div className='flex space-x-4'>
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} className='h-4 flex-1' />
          ))}
        </div>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className='flex space-x-4'>
            {Array.from({ length: 4 }).map((_, j) => (
              <Skeleton key={j} className='h-3 flex-1' />
            ))}
          </div>
        ))}
      </div>
    );
  }

  if (type === 'chart') {
    return (
      <Card>
        <CardHeader>
          <Skeleton className='h-6 w-1/3' />
          <Skeleton className='h-4 w-2/3' />
        </CardHeader>
        <CardContent>
          <div className='space-y-2'>
            <div className='flex justify-between items-end h-32'>
              {Array.from({ length: 8 }).map((_, i) => (
                <Skeleton
                  key={i}
                  className='w-8'
                  style={{ height: `${Math.random() * 80 + 20}%` }}
                />
              ))}
            </div>
            <div className='flex justify-between'>
              {Array.from({ length: 8 }).map((_, i) => (
                <Skeleton key={i} className='h-3 w-6' />
              ))}
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }

  return null;
}
